<template>
  <v-navigation-drawer
    v-if="$store.state.isUserLoggedIn"
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img :src="image" height="100%">
      <v-layout class="fill-height" tag="v-list" column>
        <v-list-tile avatar :to="'/Dashboard'">
          <v-list-tile-avatar color="none">
            <v-img :src="logo" height="34" contain />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">NXTAGRO</v-list-tile-title>
        </v-list-tile>
        <h6 id="mail">Welcome {{ $store.state.username }}!!!</h6>
        <template v-if="$store.state.meteo">
          <div class="infoWeather">
            <h6 class="weather">{{ day }}</h6>
            <hr />
            <h5 class="weather">{{ date }}</h5>
            <v-layout class="tempBox">
              <v-flex></v-flex>
              <v-flex>
                <v-icon class="sun">mdi-white-balance-sunny</v-icon>
              </v-flex>
              <v-flex>
                <!-- <br /> -->
                <h3 class="temp">
                  {{
                    $store.state.meteo.specificTypeParameters
                      .ambientTemperature
                  }}ºC
                </h3>
              </v-flex>
              <v-flex></v-flex>
            </v-layout>
            <!-- <br /> -->
            <!-- <h5 class="weather">
              Rad:
              {{
                $store.state.meteo.specificTypeParameters.solarRadiation.toFixed(
                  2
                )
              }}
              W/m
              <sup>2</sup>
            </h5> -->
            <h5 class="weather">
              Rad Acc:
              {{
                (
                  $store.state.meteo.specificTypeParameters.solarRadiationAcc /
                  10000
                ).toFixed(2)
              }}
              J
            </h5>
          </div>
        </template>
        <v-divider />
        <v-list-tile-title class="badge">
          <v-btn
            flat
            avatar
            class="v-list-item logout"
            to="/Notifications"
            :disabled="$store.state.subProject == null"
          >
            <v-badge color="error" overlap>
              <template slot="badge" v-if="this.$store.state.alerts.length > 0">
                {{ this.$store.state.alerts.length }}
              </template>
              <v-icon color="">mdi-bell</v-icon>
            </v-badge>
            <v-list-tile-action>
              <!-- <v-icon>mdi-bell-outline</v-icon>  --> </v-list-tile-action
            >ALERTS
          </v-btn>
        </v-list-tile-title>
        <v-list-tile
          :disabled="$store.state.subProject == null"
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon :disabled="$store.state.subProject == null">{{
              link.icon
            }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="link.text" />
        </v-list-tile>

        <v-list-tile-title v-if="$store.state.mail === 'jramon.zu@gmail.com'">
          <v-btn flat avatar class="v-list-item logout" to="/admin">
            <v-list-tile-action>
              <v-icon>mdi-account-plus</v-icon> </v-list-tile-action
            >Admin
          </v-btn>
        </v-list-tile-title>

        <v-list-tile-title>
          <v-btn flat avatar class="v-list-item logout" @click="logout">
            <v-list-tile-action>
              <v-icon>mdi-logout</v-icon> </v-list-tile-action
            >Log Out
          </v-btn>
        </v-list-tile-title>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
import moment from "moment-timezone";
// Utilities
import { mapMutations, mapState } from "vuex";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    date: moment()
      .locale("en")
      .format("LL"),
    day: moment()
      .locale("en")
      .format("dddd"),
    logo: "favicon.ico",
    links: [
      {
        to: "/Weather",
        icon: "mdi-white-balance-sunny",
        text: "Weather",
      },
      {
        to: "/Sensors",
        icon: "mdi-radio-tower",
        text: "Sensors",
      },
      {
        to: "/DailyReports",
        icon: "mdi-clipboard-outline",
        text: "Reports",
      },
      {
        to: "/Configuration",
        icon: "mdi-settings",
        text: "Alert Settings",
      },
      // {
      //   to: "/IrrigationLog",
      //   icon: "mdi-waves",
      //   text: "I. Instruccions",
      // },
      {
        to: "/Help",
        icon: "mdi-help-circle-outline",
        text: "Help",
      },
    ],
  }),
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    items() {
      return this.$t("Layout.View.items");
    },
    getUser() {
      return this.$store.state.user;
    },
  },
  beforeUpdate() {
    if (this.$store.state.companyId == 1 && this.$store.state.userId != 22) {
      this.links = [
        {
          to: "/Weather",
          icon: "mdi-white-balance-sunny",
          text: "Weather",
        },
        {
          to: "/Sensors",
          icon: "mdi-radio-tower",
          text: "Sensors",
        },
        {
          to: "/DailyReports",
          icon: "mdi-clipboard-outline",
          text: "Reports",
        },
        // {
        //   to: "/PlaguesDashboard",
        //   icon: "mdi-bug",
        //   text: "Plagues and D",
        // },
        {
          to: "/IrrigationLog",
          icon: "mdi-waves",
          text: "I. Instruccions",
        },
        {
          to: "/Help",
          icon: "mdi-help-circle-outline",
          text: "Help",
        },
      ];
    } else if (this.$store.state.userId == 22) {
      this.links = [
        {
          to: "/Weather",
          icon: "mdi-white-balance-sunny",
          text: "Weather",
        },
        {
          to: "/Sensors",
          icon: "mdi-radio-tower",
          text: "Sensors",
        },
        {
          to: "/DailyReports",
          icon: "mdi-clipboard-outline",
          text: "Reports",
        },
        {
          to: "/IrrigationLog",
          icon: "mdi-waves",
          text: "I. Instruccions",
        },
        {
          to: "/Help",
          icon: "mdi-help-circle-outline",
          text: "Help",
        },
      ];
    }
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss">
#app-drawer {
  z-index: 10;

  .infoWeather {
    background-color: rgba(255, 255, 255, 0.3);
    margin: 10px;
    border-radius: 5px;
  }

  .sun {
    margin-left: 40%;
    padding-top: 15px;
    margin-right: 20px;
    font-size: 20px !important;
  }

  .weather {
    text-align: center;
    font-size: 12px !important;
    margin-top: 3px !important;
    margin-bottom: 3px !important;
  }

  #mail {
    text-align: center;
    margin-top: -15px !important;
    margin-bottom: 0px !important;
  }

  .tempBox {
    margin-top: -10px;
  }

  .temp {
    margin-top: 10px;
    margin-bottom: 0px;
  }

  .v-list-item {
    margin-top: -0px !important;
    margin-bottom: -0px !important;
  }

  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .logout {
    margin-left: 0px;
  }
}
</style>
